import { render, staticRenderFns } from "./AttachmentManager.vue?vue&type=template&id=5aa63f66"
import script from "./AttachmentManager.vue?vue&type=script&lang=js"
export * from "./AttachmentManager.vue?vue&type=script&lang=js"
import style0 from "./AttachmentManager.vue?vue&type=style&index=0&id=5aa63f66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports